<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <v-card class="elevation-11">
          <v-card-text>
            <v-container>
              <h2 class="mb-3">Upload File</h2>
              <form @submit.prevent="validate()">
                <v-select id="type" label="File Type" menu-props="auto" v-model="type" :items="types" dense></v-select>

                <v-layout row class="upload">
                  <v-flex xs12>
                    <label class="lbl">Choose File &nbsp;
                      <input type="file" class="custom-file-upload" id="file" ref="file" />
                    </label>
                  </v-flex>
                </v-layout>

                <v-text-field class="txt" name="title" label="Title/Description" id="title" type="text" v-model.trim="title">
                </v-text-field>

                <v-select label="Viewable By" id="vb" class="mb-4" menu-props="auto" v-model="vb" placeholder="Select from list" :items="students" item-text="name" item-value="userId" dense></v-select>

                <v-layout row>
                  <v-flex xs12>
                    <v-btn small type="submit" :disabled="loading" :loading="loading" class="secondary">Submit
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
                    <v-btn small @click="$router.replace('/admin')" class="ml-2">Cancel</v-btn>
                  </v-flex>
                </v-layout>
              </form>

            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from "firebase";
import { db } from "../../main";
import format from "date-fns/format";
import { alphabetize } from '../../mixins/utilities.js'
export default {
  data() {
    return {
      title: "",
      type: "",
      file: "",
      vb: "",
      types: ["handouts", "notes", "tracks", "final tracks"]
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    students() {
      return alphabetize(this.$store.getters.getActiveStudents, "lname");
    }
  },
  methods: {
    validate() {
      let allClear = false

      if (this.type === "") {
        alert('Please choose a file type!')
        document.getElementById('type').focus()
        return
      } else {
        allClear = true
      }
      if (this.$refs.file.files[0] === undefined) {
        alert('Please choose a file!')
        document.getElementById('file').focus()
        return
      } else {
        allClear = true
      }
      if (this.title === "") {
        alert('Please enter a title!')
        document.getElementById('title').focus()
        return
      } else {
        allClear = true
      }
      if (this.vb === "") {
        alert('Please select viewable by!')
        document.getElementById('vb').focus()
        return
      } else {
        allClear = true
      }
      allClear ? this.uploadFile() : ''
    },
    uploadFile() {
      this.$store.dispatch("setLoading", true)
      this.file = this.$refs.file.files[0]
      let fileName = this.file.name

      let newDownload = {
        title: this.title,
        downloadURL: "",
        type: this.type,
        viewableBy: this.vb,
        name: fileName,
        uploaded: format(new Date(), "MM-DD-YYYY")
      }

      let strType = this.type.charAt(0).toUpperCase() + this.type.slice(1)
      this.$store.dispatch("setType", strType)

      let strRef = "downloads/" + this.type + "/" + fileName
      let storageRef = firebase.storage().ref(strRef)

      storageRef.put(this.file).then(() => {
        storageRef.getDownloadURL().then(url => {
          newDownload.downloadURL = url
          this.$store.dispatch("addNewDownload", newDownload)
        })
      })
    }
  }
};
</script>

<style scoped>
.container {
  padding: 0px;
}

.select {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.upload {
  margin-top: 30px;
  margin-bottom: 10px;
}

.lbl {
  font-size: 1rem;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 10px;
  width: 100%;
  cursor: pointer;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>